/* tslint:disable */

/**
 */
export class OptimumResultAna {
    prodFlowRate?: number;
    prodElmtRealweight?: number;
    avgTInitial?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/optimum-result-ana.ts